// extracted by mini-css-extract-plugin
module.exports = {"root":"SiteGroupTitle_root__25kY_"};